import { isEmpty } from '@/shared/util';

import { paramsSerializer } from '../../utils';

export const buildUrl = (url: string, params?: Record<string, unknown>): string => {
  if (isEmpty(params)) {
    return url;
  }

  const serializedParams = paramsSerializer(params);
  const hashIndex = url.indexOf('#');
  let baseUrl = url;
  let fragment = '';

  if (hashIndex >= 0) {
    baseUrl = url.slice(0, hashIndex);
    fragment = url.slice(hashIndex);
  }

  const querySeparator = baseUrl.includes('?') ? '&' : '?';

  return `${baseUrl}${querySeparator}${serializedParams}${fragment}`;
};
